import DI from '@/interface';
import { http, utils } from '@/utils';

// 未登录查询活动信息
const getActivity = function () {
  const { authKey } = utils.getUrlArgs();
  return http.get(DI.common.authInfo, {
    params: {
      authKey,
    },
  }).then((data) => {
    let result = {};
    if (data.success) {};
    return result;
  });
};

/**
 * 个人信息清单
 */
const personInfoDataList = [{
  title: '一、账号登录、认证',
  sectionDataList: [{
    scene: '授权登录',
    userTarget: '用于生成与该第三方账号绑定的APP账号，并保存登录信息；用于同步会员状态',
    infoType: '微信账号/QQ号/微博、昵称、头像（具体以用户实际授权内容为准）、设备唯一标识（IMEI、Android ID）、VIP会员信息（会员类型、会员状态、会员有效期、会员资产及其使用状态与记录(如：观赛券等)、自动续费状态）'
  },
  {
    scene: '资料维护',
    userTarget: '完善、展示用户资料',
    infoType: '昵称、头像（含上传/更换的图片信息）、签名、性别、生日、地区、手机号码'
  },
  {
    scene: '个人主页展示',
    userTarget: '完善、展示用户资料',
    infoType: '昵称、头像（含上传/更换的图片信息）、性别、年龄层、个人介绍、用户标记及等级、官方认证标记、认证信息、获赞数、关注数和关注列表、粉丝数和粉丝列表、加入圈子列表、公开发布的作品和信息（视频、回帖）、动态记录（关注、回帖）、地区'
  },
  {
    scene: '实名认证（不含第三方服务的实名认证）',
    userTarget: '落实法律法规及监管要求、确保用户身份真实性、保障系统和服务安全',
    infoType: '真实身份信息（真实姓名、身份证号、手机号码）'
  }]
}, {
  title: '二、浏览播放、搜索、下载',
  sectionDataList: [{
    scene: '浏览图文、音视频、直播',
    userTarget: '用于记录和同步用户的浏览播放记录、访问习惯、兴趣爱好，根据网络状态推荐视频清晰度',
    infoType: '设备信息（IMEI、Android ID、设备SN(硬件序列号)、手机型号、设备MAC地址、路由器MAC地址、IP地址 ）、应用内操作记录 （包括点击、浏览记录、频道/球队等页面定制记录、 点赞/分享评论/互动记录、收藏/关注/预约记录、播放记录、搜索记录、访问日期和时间）、传感器信息'
  }, {
    scene: '搜索',
    userTarget: '快速匹配搜索内容',
    infoType: '搜索的内容（如：搜索关键字）、搜索的时间以及与它们互动的次数'
  }]
}, {
  title: '三、信息上传、发布、交流互动',
  sectionDataList: [{
    scene: '信息上传、发布',
    userTarget: '完成信息发布',
    infoType: '昵称、头像、用户制作并上传发布的图文/音视频内容、传感器信息'
  }, {
    scene: '交流互动',
    userTarget: '实现与其他用户的交流互动',
    infoType: '昵称、头像、互动内容和记录（评论、弹幕、收藏/关注/预约记录、点赞/打赏/刷礼物/分享等交流互动信息）、互动数据信息（如：作品数据、粉丝数据等）'
  }, {
    scene: '账号认证（自愿申请）',
    userTarget: '了解、核对用户身份和其他认证信息，评估是否符合认证标准',
    infoType: '(1)体育从业者认证：姓名、手机号码、体育从业者身份及证明材料（职业证件照片）、账号名、账号粉丝数、登录账号的QQ/微信号；(2)优质创作者认证：姓名、手机号码、账号名、账号粉丝数、登录账号的QQ/微信号、其他平台账号及证明材料（其他平台个人主页截图等，可选填）；(3)行业名人认证：姓名、手机号码、账号名、账号粉丝数、登录账号的QQ/微信号、行业名人身份及证明材料（职业证件照片）、其他平台认证证明材料（其他平台认证截图，可选填）(4)企业机构认证：联系人信息（姓名、电话、微信号/QQ号）、账号名、登录账号的QQ/微信号、企业/组织机构名称及资质证明文件、其他平台认证证明材料（其他平台认证截图，可选填）'
  }, {
    scene: '创作中心活动',
    userTarget: '为参与活动和履行活动规则约定',
    infoType: '活动相关信息（如：投稿时提供的投稿内容和文件等，具体以各个活动实际收集的为准）'
  }]
}, {
  title: '四、下单、支付与收益管理',
  sectionDataList: [{
    scene: '商品/服务购买、支付和消费',
    userTarget: '实现交易和订单管理、完成支付、保障交易安全、实现反作弊和反欺诈、提供售后服务',
    infoType: '根据商品或服务类型收集如下部分或全部的个人信息，包括：(1)网络身份标识信息（QQ OpenID或微信OpenID、微博OpenID、IP地址）；(2)设备信息（设备ID(IDFV)、设备机型、系统版本、是否安装微信或QQ、微博）；(3)交易与消费记录：收货信息（收货人姓名、收货地址及联系电话）、订单信息（交易的商品或服务信息、交易金额、下单时间、订单商户、订单编号、订单状态、支付方式、支付账号、支付状态）、虚拟商品及服务信息及消费使用记录（如钻石、观赛券、其他兑换码等）如通过卡密等方式兑换会员/观赛券，还需要收集兑换码（如：卡密）和手机号码并进行验证'
  }, {
    scene: '配送交付',
    userTarget: '完成货物的交付及配送',
    infoType: '订单信息（交易的商品或服务信息、交易金额、下单时间、订单商户、订单编号、订单状态、支付方式、支付账号、支付状态）、收货信息（收货人姓名、收货地址及联系电话）、自物流相关服务主体处收集与交付进度相关的信息'
  }, {
    scene: '收益管理与提现',
    userTarget: '履行合同约定，用于身份校验、记录和发放收益、依法扣缴税费',
    infoType: '收益信息及相关记录、身份信息（真实姓名、身份证号）'
  }]
}, {
  title: '五、活动参与及消息通知',
  sectionDataList: [{
    scene: '活动参与（如：抽奖、问卷调查、福利签到/观看）',
    userTarget: '满足特定活动需求',
    infoType: '1. 活动参与所需的必要个人信息（如：涉及线下寄送的，需要提供收货人姓名、收货地址、收货人联系电话；涉及领取活动福利的，需要提供相关账号信息等，具体以实际活动页面申请为准 ）2. 特定活动中，还涉及剪贴板信息'
  }, {
    scene: '消息通知',
    userTarget: '用户消息告知、用户使用体验调研等用途',
    infoType: '设备信息（IMEI、Android ID）'
  }]
}, {
  title: '六、个性化内容推荐',
  sectionDataList: [{
    scene: '推荐相关性更强的内容和资讯信息',
    userTarget: '推荐相关性更强的内容和资讯信息',
    infoType: '设备信息（IMEI、Android ID）、应用内操作记录（包括点击、浏览记录、点赞/分享评论/互动记录、收藏/关注/预约记录、播放记录、搜索记录、访问日期和时间）'
  }]
}, {
  title: '七、广告（含个性化广告）',
  sectionDataList: [{
    scene: '广告推送',
    userTarget: '向用户推送可能感兴趣的广告，评估、改善广告投放和其他促销及推广活动的效果',
    infoType: '设备标识符（如：IMEI、IDFA、OAID等）、广告数据（如：曝光、点击、转化数据等）、设备信息（如：系统语言、屏幕高宽、屏幕方向等）、连接的WIFI、粗略地理位置等信息；当使用创新广告交互功能时，还涉及传感器信息'
  }]
}, {
  title: '八、客服与其他用户响应',
  sectionDataList: [{
    scene: '客服与其他用户响应',
    userTarget: '核验身份、调查事实、帮助问题解决',
    infoType: '账号信息、设备信息（IMEI、Android ID）、联系方式（用户填写的QQ号/与我们联系时使用的电话号码/电子邮箱或用户向我们主动提供的其他联系方式）、用户与客服的沟通信息（包括文字/图片/音视频/通话记录）、与用户需求相关联的其他必要信息在广告投诉时，将收集您主动提供的投诉原因、投诉理由、手机号码（选填）'
  }]
}, {
  title: '九、运营及产品安全',
  sectionDataList: [{
    scene: '网络监测、故障报错等维护运营及产品安全的场景',
    userTarget: '保障账号及系统安全，防止恶意程序及反作弊、反欺诈，进行数据统计',
    infoType: '设备信息（IMEI、Android ID、设备MAC地址、路由MAC地址、IP地址）、应用内操作记录（包括点击、浏览记录、点赞/分享评论/互动记录、收藏/关注/预约记录、播放记录、搜索记录、访问日期和时间、本应用安装使用情况）'
  }]
}, {
  title: '十、特别功能/服务场景',
  sectionDataList: [{
    scene: '投屏',
    userTarget: '建立投屏连接',
    infoType: '本地网络中的设备信息（硬件型号、生产厂家、设备解码器信息）'
  }, {
    scene: '免流量功能',
    userTarget: '通过网络状态判断用户的换卡行为，通过判断运营商、过滤无效请求以及识别用户是否为免流量用户',
    infoType: 'Android：设备信息（IMSI、IP地址、Android ID、手机型号）iOS：IP地址、运营商信息'
  }, {
    scene: 'Cookie及其他同类技术',
    userTarget: '简化用户重复操作的步骤（如：登录）、便于用户查看使用历史等',
    infoType: '账号登录信息、设备信息（IMEI、Android ID）、操作记录'
  }]
}]

/**
 * 第三方信息分享清单
 */

// 推送服务
const firstTpartyInfoDataList = [{
  companyName: '华为技术有限公司',
  productName: '华为',
  permissionContent: '收集个人信息类型：基础信息（设备品牌、设备型号、软件系统版本、储存系统、运营商信息、设备时区、设备语言、网络信息等基础信息）；设备标识（IMEI、MEID、OAID、Android ID、IMSI、位置信息：IP地址、MAC地址、GPS位置信息、基站信息、WIFI信息）；应用信息（获取软件安装列表）；其他信息（传感器信息、sim卡激活信息）',
  useScene: '推送',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://consumer.huawei.com/cn/privacy/privacy-policy/'
}, {
  companyName: '广东欧珀移动通信有限公司',
  productName: 'OPPO',
  permissionContent: '访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务',
  useScene: '推送',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://privacy.oppo.com/cn/policy/'
}, {
  companyName: '维沃移动通信有限公司',
  productName: 'VIVO',
  permissionContent: '访问网络、获取网络信息状态、获取WIFI状态、获取SD卡数据、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务',
  useScene: '推送',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.vivo.com.cn/about-vivo/privacy-policy'
}, {
  companyName: '小米科技有限责任公司',
  productName: '小米',
  permissionContent: '访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务',
  useScene: '推送',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://dev.mi.com/console/doc/detail?pId=1822'
}, {
  companyName: '珠海市的话通讯设备有限公司',
  productName: '魅族',
  permissionContent: '访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务',
  useScene: '推送',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://consumer.huawei.com/cn/privacy/privacy-policy/'
}]

// 一键登录服务
const secondTpartyInfoDataList = [{
  companyName: '中国移动通信集团有限公司',
  productName: 'com.cmic.sso',
  permissionContent: '本机号码、网络地址、手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址',
  useScene: '一键登录',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://wap.cmpassport.com/resources/html/contract.html'
}, {
  companyName: '中国联合网络通信有限公司',
  productName: '联通',
  permissionContent: '本机号码、网络地址、手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址',
  useScene: '一键登录',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://opencloud.wostore.cn/authz/resource/html/disclaimer.html'
}, {
  companyName: '中国电信集团有限公司',
  productName: '电信',
  permissionContent: '本机号码、网络地址、手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址',
  useScene: '一键登录',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl='
}]

// 其他
const otherTpartyInfoDataList = [{
  companyName: '支付宝（中国）网络技术有限公司',
  productName: '支付宝',
  permissionContent: '设备信息（IMEI/IMSI、SIM卡序列号/MAC地址）、网络设备硬件地址、网络信息、读取存储（相册、媒体和其他文件）权限、读取手机状态',
  useScene: '帮助用户完成应用内用支付宝',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://render.alipay.com/p/c/k2cx0tg8'
}, {
  companyName: '深圳市腾讯计算机系统有限公司',
  productName: '微信',
  permissionContent: '网络状态、网络信息状态、WIFI状态、手机状态、读写存储空间、改变Z轴排列任务、IMEI/IMSI、SIM卡列号/MAC地址、剪贴板、定位',
  useScene: '支持微信授权登录、微信分享、微信支付',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy'
}, {
  companyName: '南京易付宝网络科技有限公司',
  productName: '苏宁金融',
  permissionContent: 'APP包信息、网络地址、订单号、订单金额、商品名称',
  useScene: '帮助用户完成应用内用易付宝',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'http://csfs.suning.com/privacy.html#/detail?channelId=158196381110291538&name=%E6%98%93%E4%BB%98%E5%AE%9D%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96&navName=%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96&showHead=1'
}, {
  companyName: '北京微梦创科网络技术有限公司',
  productName: '微博',
  permissionContent: '设备信息（IMEI/IMSI、SIM卡序列号/MAC地址）、网络设备硬件地址、网络信息、读取存储（相册、媒体和其他文件）权限',
  useScene: '支持微博授权登录，帮助用户分享内容至微博',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3'
}, {
  companyName: '北京锐讯灵通科技有限公司',
  productName: '友盟（umeng）',
  permissionContent: '设备标识符(IMEI/Mac/Android ID/IDFA/OPENUDID/GUID/OAID、SIM卡 IMSI信息)以及社交账号公开信息、设备MAC地址、软件安装列表、获取运行中进程信息、SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况。',
  useScene: '社交平台分享、平台用户使用效果统计分析',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://developer.umeng.com/docs/147377/detail/209997'
}, {
  companyName: '深圳市腾讯计算机系统有限公司',
  productName: 'Bugly SDK',
  permissionContent: '系统状态、网络状态、WIFI状态、读取日志',
  useScene: '系统安全（崩溃捕捉）',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'
}, {
  companyName: '北京爱奇艺科技有限公司',
  productName: '爱奇艺联盟',
  permissionContent: '【双端】设备品牌、型号、系统版本、Mac地址，设备语言、网络类型、电池容量、WiFi名称、IP地址基础信息【仅Android】CUP类型、IMEI、Android ID【仅iOS】运营商信息、开机时间、系统更新时间、磁盘容量、CPU数量、内存容量、设备名称、地区名称、时区、OpenUdid、IDFV',
  useScene: '广告投放、监测归因、反作弊、广告投放统计分析',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://union.iqiyi.com/platform/privacyPolicy'
}, {
  companyName: '北京品友互动信息技术股份公司',
  productName: '品友互动',
  permissionContent: '设备标识信息（MAC地址、IMEI、Android ID、IDFV、IDFA）、设备参数及系统信息（设备型号、操作系统版本、设备名称）、网络信息（IP地址）、应用特征信息（应用包名、版本号、运行状态）',
  useScene: '广告效果优化、广告体验提升、统计分析、提升广告效果监测',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.ipinyou.com.cn/yinsicelue/'
}, {
  companyName: '加和（北京）信息科技有限公司',
  productName: '加和科技',
  permissionContent: '硬件型号、设备ID、操作系统类型、软件名称、设备识别码：IMEI、IDFA、CAID、Android ID、MAC、OAID、CookieID、OpenID',
  useScene: '广告统计分析、广告效果优化服务、广告体验优化、提升数据营销效果',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.addnewer.com/#/pc/privacypolicy'
}, {
  companyName: '西藏久和广告有限公司',
  productName: '西藏久和',
  permissionContent: '应用标识符、应用程序版本、独立设备标识符、iOS标识符（IDFA)、MAC地址、（IMEI）、设备型号、应用列表、设备WIFI地址、终端制造厂商、终端设备操作系统版本信息、系统语言、屏幕高宽、屏幕方向、屏幕DPI信息',
  useScene: '用于广告投放与监测归因、广告主统计投放结果、广告效果监测',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'http://pp.hulihuli.cn/privacy.html'
}, {
  companyName: '北京泛为信息科技有限公司',
  productName: '泛为科技',
  permissionContent: '设备标识信息（MAC地址、IMEI、Android ID、IDFV、IDFA）、设备参数及系统信息（设备型号、操作系统版本、设备名称）、网络信息（IP地址）',
  useScene: '广告统计分析、广告效果优化服务、广告体验优化、提升数据营销效果',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'http://fancydigital.com.cn/html/privacy.html'
}, {
  companyName: '秒针信息技术有限公司',
  productName: '秒针系统',
  permissionContent: '设备标识信息（IMEI、IMEI、SUPI、SUCI、IDFA、CAID、Android ID、MAC、OAID、CookieID、OpenID）、设备参数及系统信息（设备型号、操作系统版本、设备名称、设备 MAC 地址、）、软件安装列表、位置、联系人、 通话记录、日历、短信、本机电话号码、图片、音视频',
  useScene: '广告效果监测、广告统计分析、广告效果优化、提升数据营销效果',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.miaozhen.com/cn/privacy'
}, {
  companyName: '上海米漫科技有限公司',
  productName: '米漫',
  permissionContent: '设备标识信息（IMEI、IDFA、CAID、Android ID、MAC、OAID、CookieID、OpenID）、设备参数及系统信息（设备型号、操作系统版本、设备名称）、软件名称',
  useScene: '广告效果监测、广告统计分析、广告效果优化、提升数据营销效果',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'http://www.mix-mind.com/privacypolicy.html'
}, {
  companyName: '北京腾云天下科技有限公司',
  productName: 'TalkingData',
  permissionContent: '唯一设备识别 (IMEI/MEID/Android ID/DFA/OPENUDID/GUID、SIM卡IMS）、Mac地址、IP地址、ADID、安卓匿名设备标识符 (OAID/VAID/AAID）、安卓广告主标识符、IOS供应商标识符 (IDFV)IOS广告标识符 (IDFA)、设备序列号以提供统计分析服务，SDK或API版本、平台、时间戳、系统文件的创建时间、应用标识符、应用程序版本、应用分发渠道、IOS13IDFA开关状态和应用的1DFA授权状态、账户信息、应用的NFC权限情况（是或否）、设备是否文持NFC功能 （是或否）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、移动网络/国家代码、时区和网络信息 (WiFi或基站信息）、硬盘、CPU和电池使用情况',
  useScene: '校准数据准确性、提供反作弊能力、统计信息的准确性',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn'
}, {
  companyName: '北京巨量引擎网络技术有限公司及其关联方',
  productName: '穿山甲SDK ( com.bytedance )',
  permissionContent: '设备信息： 【双端】设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言等基础信息 【仅Android】Android ID、OAID（读取OAID以实现广告的精准投放和用户行为追踪，同时保护用户隐私）【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV 【仅Android】可变设备标识符（Android ID/OAID） 【仅iOS】可变设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异。应用信息：【仅Android】宿主应用包名、运行中的进程信息、版本号、应用前后台状态；传感器信息：【仅Android】加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器【仅iOS】加速度传感器、陀螺仪传感器；广告信息：【双端】对广告的展示、点击及转化等交互数据；性能数据：【双端】如崩溃数据、性能数据；其他信息：【双端】运营商信息、设备时区',
  useScene: '广告投放，广告监测归因、反作弊;摇一摇、扭一扭等广告投放、广告反作弊;减少App崩溃、提供稳定可靠的服务',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.csjplatform.com/privacy'
}, {
  companyName: '上海亦拓广告有限公司',
  productName: 'MMA 中国广告监测通用SDK',
  permissionContent: '设备标识信息（OAID、IMEI、Android ID等）、网络信息（连接的WIFI、MAC地址等',
  useScene: '广告监测',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://mmachina.cn/sdk-privacy/'
}, {
  companyName: '深圳市腾讯计算机系统有限公司',
  productName: '优量汇SDK（ com.qq.e）、SDK（com.tencent.turingfd、yaq.pro.getobjresult、yaq.pro.getVresult）',
  permissionContent: '【仅 Android】基站、附近的WIFI、连接的WIFI第三方开发者可以选择是否向本SDK提供如下信息：【双端】精确位置信息【双端】获取SD卡数据、设备MAC地址、软件安装列表、获取运行中进程信息、设备制造商、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、加速度传感器【仅Android】磁场传感器【仅Android】OAID【仅Android】 IMEI/MEID（Device ID）、Android ID【仅iOS】IDFV、 IDFA【双端】宿主应用的包名、版本号【仅Android】 宿主应用的进程名称、运行状态、可疑行为【双端】应用安装信息【双端】如产品交互数据、广告数据（如展示、点击、转化广告数据）【双端】如崩溃数据、性能数据',
  useScene: '广告投放、广告归因、广告监测、反作弊、最大程度减少App崩溃、确保服务器正常运行、提升可扩展性和性能',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983'
}, {
  companyName: '苏宁易购集团股份有限公司',
  productName: '苏宁底层SDK ( com.suning )',
  permissionContent: '可变设备标识信息（Android ID[读取 Andorid ID以实现埋点采集实现数据统计]/OAID/IDFA）、设备参数及系统信息（操作系统及版本号、设备型号、生产厂商）、网络相关信息（IP地址、网络运营商）',
  useScene: '苏宁小程序、数据埋点统计、底层框架、播放sdk中台服务程序',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://hc.suning.com/privacy/index.htm'
}, {
  companyName: 'PP互娱',
  productName: 'com.component、com.ksdk、com.lygame',
  permissionContent: '设备品牌、型号，系统软件版本、OAID、IMEI、IMSI、设备MAC地址、软件安装列表、获取已安装APP信息、获取运行中进程信息、访问网络、网络状态、获取手机状态、运营商信息、系统语言、软件名称com.component 获取 IMSI频率为 4次/分钟',
  useScene: '广告展示游戏',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'http://download.mgc-games.com/privacy/mgc_privacy.html'
}, {
  companyName: '网易七鱼',
  productName: 'com.netease',
  permissionContent: '需要用户授权的设备权限：麦克风权限、摄像头和相册权限；设备信息：设备品牌及型号、设备所运行的系统版本、名称、编辑版本信息、SD卡数据；网络信息：网络状态、wifi信息、IP地址；日志信息：浏览器类型及其版本信息、网络连接类型及状态、云信通信服务运行日志信息；Android应用的应用包名',
  useScene: 'JJ斗地主直播',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://qi.163.com/termsService#ten'
}, {
  companyName: '高德地图',
  productName: 'com.amap.api',
  permissionContent: '位置信息（经纬度、精确位置、粗略位置）、设备信息【如IP地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强调的信息、蓝牙信息、传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC地址、OAID、IMSI、硬件序列号）、当前应用信息（应用名、应用版本、操作系统）',
  useScene: '帮助用户在发布信息时定位位置',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://lbs.amap.com/home/privacy/'
}, {
  companyName: '网易易盾',
  productName: 'com.netease.nis',
  permissionContent: '设备唯一识别码（设备序列号、OAID、IDFV、AAID）、设备品牌、设备名称、设备型号及设备系统类型、详细设置及版本信息。',
  useScene: '判定设备是否处于异常状态',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://dun.163.com/clause/privacy'
}, {
  companyName: '友盟',
  productName: 'com.umeng',
  permissionContent: '设备序列号、设备标识符（Android如Android ID、IMEI、MEID、IMSI、OAID、Serial，iOS如IDFV、IDFA）、MAC地址、IP 地址、位置信息（如GPS、WLAN接入点、蓝牙和基站、经纬度）、设备传感器、应用列表信息、当前应用信息（应用名、应用版本号）、网络信息（WiFi信息、基站信息、SSID、BSSID）',
  useScene: '提供统计分析与反作弊服务',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.umeng.com/page/policy'
}, {
  companyName: '行吟信息科技(上海)有限公司',
  productName: '小红书分享SDK',
  permissionContent: '设备信息(Android ID/IDFA/OAID/操作系统、系统版本、设备型号)',
  useScene: '内容分享，用户分享图片和视频至小红书时使用',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://agree.xiaohongshu.com/h5/terms/ZXXY20230525001/-1'
}, {
  companyName: '北京快手科技有限公司',
  productName: '快手SDK',
  permissionContent: '设备品牌，设备型号，软件系统版本，存储信息，设备序列号，安装列表，运行中的进程，运营商信息、设备时区，设备语言，网络信息、设备标识符（安卓如Android ID、IMEI、OAID、IMSI、GAID、MEID、Serial，iOS如IDFV、IDFA）、IP地址、MAC地址、WIFI信息、SD卡上的内容、读取手机状态和身份、获取传感器数据、注册传感器监听器、联系人、通话记录、日历、短信、本机电话号码、图片、音频、访问精确定位（此调用为三方调用，已做禁止处理即使调用也拿不到数据）；应用信息：（【仅Android】应用安装列表、安装状态、后台静默时，存在监听手机安装、卸载应用情况，主要注册广播（android.intent.action.PACKAGE_ADDED、android.intent.action.PACKAGE_REMOVED））；',
  useScene: '用于统计分析您在 App 内的使用效果，从而改进我们的产品和服务 ，和请求商业化效果广告信息',
  shareStyle: 'SDK本机采集',
  processStyle: '通过去标识、加密等方式进行传输和处理',
  privacyPolicy: '点击查第三方隐私保护政策',
  targetUrl: 'https://www.kuaishou.com/about/policy?tab=privacy'
}]

export {
  getActivity,
  personInfoDataList,
  firstTpartyInfoDataList,
  secondTpartyInfoDataList,
  otherTpartyInfoDataList
};
